module.exports = __webpack_public_path__ + "img/5.226de7a9.jpg";